import React, { useMemo } from "react";
import { ViewStyle } from "react-native";
import { useAppSelector } from "../redux/store";
import { useTranslation } from "react-i18next";
import { getValueDisplayTableComponent } from "./valueDisplayTableRegistry";

type Props = {
  field: any;
  value: any;
  collectionPickerContainerStyles?: ViewStyle;
};

export const ValueDisplayTable = ({ field, value }: Props) => {
  const theme = useAppSelector((state) => state.auth.theme);
  const { t } = useTranslation();

  const rentalPeriodString = useMemo(() => {
    if (value?.startDate && value?.endDate) {
      const startDate = new Date(value.startDate.seconds * 1000);
      const endDate = new Date(value.endDate.seconds * 1000);
      return `${startDate.toLocaleString("ru-RU").split(",")[0]} - ${endDate.toLocaleString("ru-RU").split(",")[0]}`;
    }

    return "";
  }, [value?.startDate, value?.endDate]);

  const linkColor = theme === "light" ? "#1E40AF" : "#90d5ff";
  const FieldComponent = getValueDisplayTableComponent(field.type);

  return (
    <FieldComponent
      field={field}
      value={value}
      t={t}
      linkColor={linkColor}
      rentalPeriodString={rentalPeriodString}
    />
  );
};
